<i18n>
{
  "fr": {    
    "auditor-infos-tab": "Informations pour l'auditeur",
    "auditor-note": "Note à l'auditeur",
    "auditor-note-empty": "Aucune note pour l'auditeur",
    "auditor-note-add": "Ajouter une note",
    "auditor-note-edit": "Éditer la note",
    "auditor-note-placeholder": "Note pour l'auditeur",
    "responsible-department":"Département(s) ou personne(s) responsable(s)",
    "responsible-note-empty": "Aucun(e) département(s) ou personne(s) spécifié(s). Par défault, le responsable de la tâche sera utilisé.",
    "responsible-note-add": "Ajouter un responsable",
    "responsible-note-edit": "Éditer le responsable",
    "responsible-note-placeholder": "Responsable de la tâche"   
  },
  "en": {    
    "auditor-infos-tab": "Information for the auditor",
    "auditor-note": "Note for the auditeur",
    "auditor-note-empty": "No note for the auditor",
    "auditor-note-add": "Add note",
    "auditor-note-edit": "Edit note",
    "auditor-note-placeholder": "Note for the auditor",
    "responsible-department":"Responsible department(s) or person(s)",
    "responsible-note-empty": "No department(s) or person(s) specified. By default, the assignee for the task will be used.",
    "responsible-note-add": "Add a responsible",
    "responsible-note-edit": "Update responsible",
    "responsible-note-placeholder": "Task responsible"    
  }
}
</i18n>
<template>
  <b-tab-item class="pt-24px" :value="tabName">
    <template #header>
      {{ $t('auditor-infos-tab') }}
      <tab-dot v-show="hasAuditorInfos" :isSpecific="isSpecific" />
    </template>

    <hr class="mt-0 mb-16px" />

    <div class="has-max-width-768">
      <label class="label">{{ $t('auditor-note') }}</label>
      <editable-field
        v-model="indicator.auditorNote"
        :edit-label="indicator.auditorNote ? $t('auditor-note-edit') : $t('auditor-note-add')"
        :readOnly="readOnly"
        @save="({ value, closeEditor }) => saveAuditorNote(value, closeEditor)"
      >
        <p v-if="indicator.auditorNote" class="is-size-7 mb-8px" v-html="$format.nl2br(indicator.auditorNote)" />
        <p v-else class="is-size-7 mb-8px">{{ $t('auditor-note-empty') }}</p>

        <template v-slot:editor="editor">
          <s-field :value="editor.model">
            <b-input
              v-focus
              type="textarea"
              size="is-small"
              v-model="editor.model"
              :placeholder="$t('auditor-note-placeholder')"
              @input="editor.update"
            />
          </s-field>
        </template>
      </editable-field>
    </div>

    <hr class="my-16px" />

    <div class="has-max-width-768">
      <label class="label mt-24px">{{ $t('responsible-department') }}</label>
      <editable-field
        v-model="indicator.responsibleNote"
        :readOnly="readOnly"
        :edit-label="indicator.responsibleNote ? $t('responsible-note-edit') : $t('responsible-note-add')"
        @save="({ value, closeEditor }) => saveResponsibleNote(value, closeEditor)"
      >
        <p v-if="indicator.responsibleNote" class="is-size-7 mb-8px" v-html="$format.nl2br(indicator.responsibleNote)" />
        <p v-else class="is-size-7 mb-8px">{{ $t('responsible-note-empty') }}</p>

        <template v-slot:editor="editor">
          <s-field :value="editor.model">
            <b-input
              v-focus
              type="text"
              size="is-small"
              v-model="editor.model"
              :placeholder="$t('responsible-note-placeholder')"
              @input="editor.update"
            />
          </s-field>
        </template>
      </editable-field>
    </div>

    <hr class="mb-0 mt-16px" />
  </b-tab-item>
</template>

<script>
import EditableField from '@/components/generic/editable-field'
import SField from '@/components/form/field'
import TabDot from '@/components/generic/tab-dot'

export default {
  components: {
    EditableField,
    SField,
    TabDot
  },
  props: {
    indicator: { type: Object, required: true },
    tabName: { type: String, required: true },
    isSpecific: Boolean,
    readOnly: Boolean
  },
  computed: {
    hasAuditorInfos() {
      return (
        this.indicator &&
        ((this.indicator.auditorNote && this.indicator.auditorNote.trim()) ||
          (this.indicator.responsibleNote && this.indicator.responsibleNote.trim()))
      )
    }
  },
  methods: {
    saveAuditorNote(value, closeEditor) {
      this.$emit('onSaveAuditorNote', value, closeEditor)
    },
    saveResponsibleNote(value, closeEditor) {
      this.$emit('onSaveResponsibleNote', value, closeEditor)
    }
  }
}
</script>